module.exports = __webpack_public_path__ + "static/media/warningIcon.9da6a0f4.svg";